import { handleActions } from 'redux-actions'
import { setLocalItem, getLocalItem } from '../../utils'
import { BotSettings } from '../../model/bot.model'
import {
    Set_Bot_Settings_Info,
    Delete_Bot_Settings_Info,
} from '../actions/settings'

export const Local_User_Key = 'l_bot_st_k'

/** 用户信息初始化 */
const initSettingsInfo = (): BotSettings | null => {
    return getLocalItem(Local_User_Key)
}

const settingsReducer = handleActions(
    {
        /** 存储机器人设置 */
        [Set_Bot_Settings_Info]: (state, { payload }) => {
            if (!payload) return null
            setLocalItem(Local_User_Key, payload)
            return payload
        },
        /** 删除机器人设置 */
        [Delete_Bot_Settings_Info]: (state, { payload }) => {
            localStorage.removeItem(Local_User_Key)
            return null
        },
    },
    initSettingsInfo()
)

export default settingsReducer
